module.exports = __webpack_public_path__ + "media/put6.c7b23c68.mp4";